export default {
  namespaced: true,
  state: {
    listCustomer: [
      {
        name: '',
        phoneNumber: '',
        contactSource: '',
        dateOfBirth: '',
        diseaseType: '',
        course: '',
        coach: '',
        packageId: '',
        customerPartnerId: '',
        useZaloGroup: { text: 'Có', value: true },
      },
    ],
    courses: [],
    coaches: [],
    partners: [],
  },
  actions: {
    updateCustomer({ commit }, { index, customerReceiveData }) {
      commit('UPDATE_CUSTOMER', { index, customerReceiveData });
    },
    addCustomer({ commit }) {
      commit('ADD_CUSTOMER');
    },
    deleteCustomer({ commit }, index) {
      commit('DELETE_CUSTOMER', index);
    },
    setCourses({ commit }, courses) {
      commit('SET_COURSES', courses);
    },
    setPartners({ commit }, partners) {
      commit('SET_PARTNERS', partners);
    },
    setCoaches({ commit }, coaches) {
      commit('SET_COACHES', coaches);
    },
    resetListCustomer({ commit }) {
      commit('RESET_LISTCUSTOMER');
    },
  },
  mutations: {
    UPDATE_CUSTOMER(state, { index, customerReceiveData }) {
      state.listCustomer[index] = customerReceiveData;
    },
    ADD_CUSTOMER(state) {
      state.listCustomer.push({
        name: '',
        phoneNumber: '',
        contactSource: '',
        dateOfBirth: '',
        diseaseType: '',
        course: '',
        coach: '',
        packageId: '',
        customerPartnerId: '',
        useZaloGroup: { text: 'Có', value: true },
      });
    },
    DELETE_CUSTOMER(state, index) {
      state.listCustomer.splice(index, 1);
    },
    SET_COURSES(state, courses) {
      state.courses = courses;
    },
    SET_COACHES(state, coaches) {
      state.coaches = coaches;
    },
    SET_PARTNERS(state, partners) {
      state.partners = partners;
    },
    RESET_LISTCUSTOMER(state) {
      state.listCustomer = [];
    },
  },
};
